import type { GetIsComponentStoreReadOnlyOptions } from "./types";

export const getIsComponentStoreReadOnly = ({
  connectedContentOptimizationStepCount,
  isCanvasActive,
  launchLimit,
  isStepConnected = true,
  isStepDraft = false,
}: GetIsComponentStoreReadOnlyOptions): boolean => {
  if (!isCanvasActive || !isStepConnected || isStepDraft) {
    return false;
  }

  if (!launchLimit) {
    return true;
  }

  const { limit, activeCount } = launchLimit;
  if (typeof activeCount !== "number" || !Number.isFinite(activeCount)) {
    return true;
  }

  if (limit === null) {
    return false;
  }

  if (typeof limit !== "number" || !Number.isFinite(limit)) {
    return true;
  }

  return activeCount + connectedContentOptimizationStepCount > limit;
};
